"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.charLevelReplace = void 0;
function charLevelReplace(text, from, to) {
    var fromChars = from.split("");
    var toChars = to.split("");
    for (var i in fromChars) {
        if (Object.prototype.hasOwnProperty.call(fromChars, i)) {
            text = text.replace(new RegExp(fromChars[i], "g"), toChars[i]);
        }
    }
    return text;
}
exports.charLevelReplace = charLevelReplace;
